"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import animalIcon from "@/assets/animal-icon.svg";

/** Full-screen dimmed overlay with the pet graphic running across the screen, shown while the funnel waits
 * for the backend (recommendations, offer creation). Blocks clicks underneath. */
const LoadingOverlay: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="pet-loader-overlay" role="status" aria-live="polite" aria-label={t("common.loading", "Loading")}>
      <div className="pet-loader-runner">
        <img src={animalIcon} alt="" />
      </div>
    </div>
  );
};

export default LoadingOverlay;
